import Decimal from 'decimal.js';
import { utils } from "../utils";
export let DiscountType = /*#__PURE__*/function (DiscountType) {
  DiscountType["Value"] = "value";
  DiscountType["Percent"] = "percent";
  return DiscountType;
}({});
export let DiscountDTOType = /*#__PURE__*/function (DiscountDTOType) {
  DiscountDTOType["Percent"] = "percent";
  DiscountDTOType["Value"] = "value";
  DiscountDTOType["None"] = "none";
  return DiscountDTOType;
}({});
export class DiscountModel {
  static make(type, amount) {
    return new DiscountModel({
      type,
      amount: new Decimal(amount)
    });
  }
  static makePercent(amount) {
    return DiscountModel.make(DiscountType.Percent, amount);
  }
  static makeValue(amount) {
    return DiscountModel.make(DiscountType.Value, amount);
  }
  static fromDTO(dto) {
    if (dto == null) return null;
    switch (dto.type) {
      case DiscountDTOType.Percent:
        return new DiscountModel({
          type: DiscountType.Percent,
          amount: new Decimal(dto.temp_amount).div(100)
        });
      case DiscountDTOType.Value:
        return new DiscountModel({
          type: DiscountType.Value,
          amount: new Decimal(dto.temp_amount).div(100)
        });
      case DiscountDTOType.None:
        return null;
    }
  }
  static fromDBDTO(dto) {
    return dto && dto.type !== DiscountDTOType.None ? new DiscountModel({
      type: dto.type === DiscountDTOType.Percent ? DiscountType.Percent : DiscountType.Value,
      amount: new Decimal(dto.decimal).div(100)
    }) : null;
  }
  constructor(discount) {
    this.discount = discount;
  }
  toDTO() {
    return {
      type: this.discount.type === DiscountType.Percent ? DiscountDTOType.Percent : DiscountDTOType.Value,
      amount: this.discount.amount.toNumber(),
      temp_amount: this.discount.amount.mul(100).toNumber()
    };
  }
  toDBDTO() {
    return {
      type: this.discount.type === DiscountType.Percent ? DiscountDTOType.Percent : DiscountDTOType.Value,
      decimal: this.discount.amount.mul(100).toNumber()
    };
  }
  type() {
    return this.discount.type;
  }
  isPercent() {
    return this.discount.type === DiscountType.Percent;
  }
  isValue() {
    return this.discount.type === DiscountType.Value;
  }
  isSameAs(other) {
    return this.discount.type === other.discount.type && this.discount.amount.equals(other.discount.amount);
  }
  amount() {
    return this.discount.amount;
  }
  accept(visitor) {
    switch (this.discount.type) {
      case DiscountType.Value:
        return visitor.whenValue();
      case DiscountType.Percent:
        return visitor.whenPercent();
    }
  }
  format() {
    let {
      showValueAsNegative
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this.discount.type === DiscountType.Value ? utils.formatDollarAmount(showValueAsNegative ? this.discount.amount.neg() : this.discount.amount) : "".concat(utils.formatNumberWithCommas(this.discount.amount), "%");
  }
}